import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=1e4d7343&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=1e4d7343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4d7343",
  null
  
)

export default component.exports